<template>
	<div class="yh-bg-color">
		<div style="float: left;margin-top: 20px;margin-left: 20px;"> <!-- :src="require('@/assets/images/logo.png')" -->
			<el-image style="width: 240px; height:76px"  :src="logourl" fit="cover"></el-image>
		</div>
		<div style="float: right;width: 320px;height: 370px;margin-top: 160px;
			margin-right: 120px; border-radius: 10px;background-color: #fff;">
			<div style="height: 100px;line-height: 100px;display: flex;justify-content: center;align-items: center;">
				<span style="margin-left: 0px;">{{ title }}</span>
			</div>	
			<el-form style="padding-left: 40px;padding-right: 40px;">
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-user-solid" autofocus placeholder="请输入账号" v-model="formdata.username"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-star-on" type="password" :show-password="true" placeholder="请输入密码" v-model="formdata.userpwd"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-select clearable style="width: 100%;" v-model="formdata.citycode" placeholder="请选择城市" @change="changeCity">
						<el-option v-for="item in cityList" :key="item.id" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item style="margin-bottom:0px;">
					<el-row>
						<el-col :span="12">
							 <el-input clearable prefix-icon="el-icon-warning" placeholder="短信验证码" v-model="formdata.smscode"></el-input>
						</el-col>
						<el-col :span="12">
							<el-button type="primary" :disabled="smsdisable" @click="sendSms">{{smsbtnword}}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item style="margin-bottom:0px;">
				    <div style="float: right;">
						<a @click="gotoForgotPwd">忘记密码？</a>
					</div>
				</el-form-item> -->
				<el-form-item >
				   <el-button style="width: 100%;" type="primary" @click="submitLogin">登录</el-button>
				</el-form-item>
			</el-form>
				
		</div>	
		
		<div style="position: absolute;bottom: 0px;margin-bottom: 20px;color: #7EA8EB;
			text-align: center;width: 99%;font-size: 12px;">
			<div style="">
				Copyright @ 2024-2099 jzhongtech. All Right Reserved.
			</div>
			<div style="">
				@ 2024-2099 版权所有 杭州节众 | 浙ICP备2025208028号-1X
			</div>
		</div>
	</div>
</template>

<script>
	import {userLogin,queryCityList } from '/static/apiUrl.js'
	//import { sysname } from '/public/sysname'
	export default {
		name : 'YHLogin',
		data() {
			return {
				logourl : "logo.png",
				smsbtnword : '发送验证码',
				countdown : 60,
				smsdisable : false,
				//leftlogourl : "@/assets/images/yh-logo-1.png",
				//title : '节众物管平台 - ' + window.sysname,
				title : '节众物管平台',
				formdata : {
					username : '',
					userpwd : '',
					smscode : '',
					cityname : '',
					citycode : '',
				},
				cityList : [],
			}
		},
		mounted() {
			this.initCityList()
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
			console.log(window.sysname)
		},
		beforeCreate () {
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		beforeDestroy () {
			document.querySelector('body').setAttribute('style', 'background-color:#FFF')
		},
		methods: {
			gotoForgotPwd(){
				console.log('忘记密码')
				this.$router.push({ name: 'ForgotPassword' });
			},
			changeCity(e){
				//console.log(e)
				this.formdata.cityname = this.cityList.find(item => item.value == e).label
				//console.log(this.formdata.cityname)
				localStorage.setItem("citycode",this.formdata.citycode)
				localStorage.setItem("cityname",this.formdata.cityname)
			},
			initCityList(){
				queryCityList().then(res => {
					if (0 == res.code) {
						this.cityList = res.data.map(item => ({
							id: item.Sys_Citys_Id,
							label: item.Sys_Citys_Name,
							value: item.Sys_Citys_Code
						}))
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							type: 'error'
						})
					}
				})
			},
			submitLogin(){
				if(this.formdata.username === null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请输入账号',
						type: 'error'
					});
					return;
				}
				if(this.formdata.userpwd === null || this.formdata.userpwd == ''){
					this.$message({
						showClose: true,
						message: '请输入密码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.citycode === null || this.formdata.citycode == ''){
					this.$message({
						showClose: true,
						message: '请选择城市',
						type: 'error'
					});
					return;
				}
				/* if(this.formdata.smscode === null || this.formdata.smscode == ''){
					this.$message({
						showClose: true,
						message: '请输入短信验证码',
						type: 'error'
					});
					return;
				} */
				userLogin({
					username: this.formdata.username,
					userpwd: this.$md5(this.formdata.userpwd),
					//smscode: this.formdata.smscode
				}).then((res) => {
					console.log(this.formdata.citycode)
					if(0 == res.code){
						let userinfo = {
							realname : res.datas.realname,
							username : res.datas.account,
							userid: res.datas.id,
							org_id : res.datas.orgid
						}
						localStorage.setItem("citycode",this.formdata.citycode)
						localStorage.setItem("cityname",this.formdata.cityname)
						localStorage.setItem("bUserinfo",JSON.stringify(userinfo))
						sessionStorage.setItem("authToken", res.message);
						this.$router.push({ name: 'Home' });
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error'
						});
					}
				}).catch((err) => {
					console.log(err)
				})
				//
			},
			sendSms(){
				if(this.formdata.username == null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请先输入账号',
						type: 'error'
					});
				}else{
					//发送短信验证码
					this.GetSmsCode("login")
					
					this.smsdisable = true
					this.smsbtnword = '60s后重试'
					let pthis = this
					let timeout = setInterval(()=>{
						pthis.countdown--
						if(pthis.countdown == 0){
							clearInterval(timeout)
							pthis.smsdisable = false
							pthis.smsbtnword = '发送验证码'
							pthis.countdown = 60
						}else{
							pthis.smsbtnword = pthis.countdown + 's后重试'
						}
					},1000)
				}
			},
			GetSmsCode(type){
				/* getSmsCode({
					username: this.formdata.username,
					type: type,
				}).then(res => {
					if (0 == res.code) {
						console.log("")
					}
				}) */
			},
		}
	}
</script>

<style scoped>
	
</style>